/*
 * @Description: 市场准入管理
 * @Date: 2026-08-31
 */
import { route } from './src/router';

const name = 'market-access-mgmt';

export { name, route };
